/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Paper,
  MuiThemeProvider,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { actionTableMuiTheme } from "../../table/table_styles";
import { searchSchools } from "../../../../app/crud/api/schools.crud";
import { Add } from "@material-ui/icons";
import {
  addPermisssion,
  updatePermisssion,
} from "../../../crud/api/Permission.crud";
import axios from "axios";
import { BASE_URL_v2 } from "../../../crud/helpers/routes";
import notice from "../../../utils/notice";

const Permission = ({ schoolActions, settingLoader }) => {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  const [schools, setSchools] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [showButtonSave, setShowButtonSave] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    searchSchools("", setSchools);
  }, []);

  const getNewPermission = (school_id, read, module_id) => {
    const resolvedModuleId = module_id ?? 1;
    const existing = permissions.find(
      (x) => x.module_id === resolvedModuleId && x.school_id === school_id,
    );
    const school = schools.find((s) => s.id === school_id);
    const backendPerm = school?.permissions?.find(
      (x) => x.module_id === resolvedModuleId,
    );
    const existingId = existing?.id || backendPerm?.id;
    return {
      ...(existingId ? { id: existingId } : {}),
      school_id: school_id,
      read: read !== null ? read : false,
      write: false,
      update_p: false,
      delete_p: false,
      module_id: resolvedModuleId,
    };
  };
  const selectPermission = (event, permision, meta) => {
    const school = schools[meta.rowIndex];
    const resolvedModuleId = permision.module_id ?? 1;
    const newPermision = getNewPermission(
      school.id,
      permision.read !== undefined ? !permision.read : false,
      resolvedModuleId,
    );
    const updatedSchools = schools.map((s, i) =>
      i === meta.rowIndex ? { ...s, permissions: [newPermision] } : s,
    );
    const filteredPermissions = permissions.filter(
      (x) => !(x.module_id === resolvedModuleId && x.school_id === school.id),
    );

    setSchools(updatedSchools);
    setShowButtonSave(true);
    setPermissions([newPermision, ...filteredPermissions]);
  };
  const isCheckAllSchool = () => {
    const school = schools.filter(
      (x) =>
        (x.permissions.length > 0 && x.permissions[0].read === false) ||
        x.permissions.length === 0,
    );
    if (school.length === 0) return true;
    return false;
  };
  const selectAllSchool = (event) => {
    const checked = event.currentTarget.checked;
    const permissionSelected = [];
    const updatedSchools = schools.map((x) => {
      const newPermision = getNewPermission(x.id, checked, 1);
      permissionSelected.push(newPermision);
      return { ...x, permissions: [newPermision] };
    });
    setPermissions(permissionSelected);
    setShowButtonSave(true);
    setSchools(updatedSchools);
  };
  const saveChanges = async () => {
    const toCreate = permissions.filter((p) => !p.id);
    const toUpdate = permissions.filter((p) => p.id);

    setIsSaving(true);
    try {
      const [createResult, updateResult] = await Promise.allSettled([
        toCreate.length > 0 ? addPermisssion(toCreate) : Promise.resolve(),
        toUpdate.length > 0 ? updatePermisssion(toUpdate) : Promise.resolve(),
      ]);

      const createFailed =
        toCreate.length > 0 && createResult.status === "rejected";
      const updateFailed =
        toUpdate.length > 0 && updateResult.status === "rejected";

      if (!createFailed && !updateFailed) {
        notice("Permissions saved successfully", "success");
        setShowButtonSave(false);
        setPermissions([]);
        try {
          await searchSchools("", setSchools);
        } catch {
          notice("Error refreshing schools list");
        }
      } else {
        setPermissions([
          ...(createFailed ? toCreate : []),
          ...(updateFailed ? toUpdate : []),
        ]);
        if (!createFailed || !updateFailed) {
          try {
            await searchSchools("", setSchools);
          } catch {
            notice("Error refreshing schools list", "error");
          }
        }
        notice("Some permissions failed to save", "error");
      }
    } finally {
      setIsSaving(false);
    }
  };
  const columns = [
    {
      name: "name",
      label: "Organizations",
      options: {
        filter: false,
        sort: false,
        display: true,
      },
    },
    {
      name: "permissions",
      label: "View dashboard",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => {
          const schoolName = schools[meta.rowIndex]?.name ?? "school";
          // Guard against the API ever returning a school without a
          // `permissions` key (MUIDataTable passes that field's value
          // straight in as `value`). Undefined would TypeError on
          // .length and [0]; an empty array path renders unchecked
          // and selectPermission still gets a sane default to work
          // against.
          const perms = Array.isArray(value) ? value : [];
          const perm = perms[0] ?? { read: false };
          return (
            <label>
              <input
                type="checkbox"
                name=""
                aria-label={`View dashboard for ${schoolName}`}
                checked={!!perm.read}
                onChange={(event) => {
                  selectPermission(event, perm, meta);
                }}
              />
              <span></span>
            </label>
          );
        },
      },
    },
    {
      name: "permissions",
      label: "Mindflow",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => {
          const schoolName = schools[meta.rowIndex]?.name ?? "school";
          const perms = Array.isArray(value) ? value : [];
          const perm = perms[0];
          return (
            <label>
              <input
                type="checkbox"
                name=""
                aria-label={`Mindflow for ${schoolName}`}
                checked={isMindflowCheckActive(perm, meta)}
                onChange={(event) => {
                  handleMindflowStatusChange(event, perm, meta);
                }}
              />
              <span></span>
            </label>
          );
        },
      },
    },
  ];

  const isMindflowCheckActive = (permision, meta) => {
    const school = schools[meta.rowIndex];
    return school.active_mindflow;
  };

  const handleMindflowStatusChange = async (event, permision, meta) => {
    const school = schools[meta.rowIndex];
    if (!school) {
      notice("Error updating permissions", "error");
      return;
    }
    const { id, active_mindflow } = school;
    if (id === undefined) {
      notice("Error updating permissions", "error");
      return;
    }
    try {
      await axios.post(
        `${BASE_URL_v2}/schools/check_uncheck_mindflow?login=email`,
        { id_school: id, active: !active_mindflow },
      );
      notice("Permissions updated", "success");
      await searchSchools("", setSchools);
    } catch (err) {
      notice("Error updating permissions", "error");
      console.error(err);
    }
  };

  const options = {
    // The page fetches every school in one shot via
    // searchSchools("", setSchools) and stores them in a flat
    // useState array. The previous config declared
    // `serverSide: true` plus `count: schools.count` and
    // `rowsPerPage: schools.rowsPerPage` — both undefined on a
    // plain Array. MUIDataTable then rendered a bogus paginator
    // footer ("1-10 of 20" while the table actually showed all
    // rows at once). Switch to client-side pagination so the
    // footer's range, total, and rows-rendered all agree.
    serverSide: false,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "50em" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "school.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
  };

  return (
    <>
      <div className="table-container">
        {schools.length > 0 ? (
          <div className="pb-4 d-flex justify-content-end align-items-end">
            <label style={{ marginRight: "20px" }}>
              <input
                type="checkbox"
                name=""
                checked={isCheckAllSchool()}
                onChange={(event) => {
                  selectAllSchool(event);
                }}
              />
              <span> Check All</span>
            </label>
            {showButtonSave === true ? (
              <Button
                id="save_parmissions"
                variant="contained"
                color="secondary"
                disabled={isSaving}
                onClick={() => saveChanges()}
              >
                <Add /> {isSaving ? "Saving…" : "Save Changes"}
              </Button>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        <Paper>
          <MuiThemeProvider theme={actionTableMuiTheme()}>
            <MUIDataTable
              // title="Admin"
              columns={columns}
              data={schools}
              options={options}
            />
          </MuiThemeProvider>
        </Paper>
      </div>
    </>
  );
};

export default Permission;
